import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import {useAuthUtils} from "@/hooks/useAuthUtils.ts";

export default function UserNotFound() {
  const { t } = useTranslation();
  const {authRedirect} = useAuthUtils();
  return (
    <div className="mb-[100px] ml-[70px] mt-[50px]">
      <h1 className="max-w-[700px] text-4xl  font-bold">
        {t('Error.PageNotFound')}
      </h1>

      <div className="mt-[30px] flex max-w-[700px] flex-col gap-8 text-lg">
        <p className="font-bold">{t('Error.NotFoundCurrentlyUnavailable')}</p>
        <p>{t('Error.UnavailabilityFactorsMessage')}</p>
        <p>{t('Error.ReturnHomePageMessage')}</p>
        <div className="flex">
          <Button
            variant="default"
            onClick={() => authRedirect()}
          >
            {t('Error.ReturnToDashboard')}
          </Button>
        </div>

        <p>
          <span className="font-bold">{t('Error.ErrorCode')}:</span>{' '}
          {t('Error.NotFoundCode')}
        </p>
      </div>
    </div>
  );
}
